import React from 'react';

const LogoMark = ({ size = 36, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <rect x="1.5" y="1.5" width="45" height="45" rx="9" stroke="#EAB308" strokeWidth="2" />
    <path
      d="M14 35V24C14 17.4 18.6 12.5 24 12.5C29.4 12.5 34 17.4 34 24V35"
      stroke="#EAB308"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <line x1="11" y1="35" x2="37" y2="35" stroke="#EAB308" strokeWidth="2.5" strokeLinecap="round" />
    <circle cx="24" cy="21" r="1.8" fill="#EAB308" />
  </svg>
);

export default LogoMark;
